import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background: #3e2723;
  padding: 40px 0;
  text-align: center;
`;

const Copyright = styled.p`
  color: #f5e6d3;
  font-size: 14px;
  letter-spacing: 1px;
  margin: 0;
`;

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <Copyright>© {currentYear} Damascena. All rights reserved.</Copyright>
    </FooterContainer>
  );
};